exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-3d354e87] {\n  margin-top: -0.75rem;\n}\n.title[data-v-3d354e87] {\n  margin-top: 0.75rem;\n  position: relative;\n  text-indent: 0.4rem;\n}\n.title[data-v-3d354e87]::after {\n  content: \"\";\n  width: 0.15rem;\n  height: 0.75rem;\n  left: 0;\n  top: 0;\n  position: absolute;\n  background: #333;\n}\n.head[data-v-3d354e87] {\n  margin: 0.75rem 0 0.4rem 0;\n}\n.cont[data-v-3d354e87] {\n  line-height: 0.9rem;\n}\n.cont p[data-v-3d354e87] {\n  margin-bottom: 0.4rem;\n}", ""]);

// exports
